import { render, staticRenderFns } from "./ResortMenu.vue?vue&type=template&id=6b893fb4&"
import script from "./ResortMenu.vue?vue&type=script&lang=js&"
export * from "./ResortMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports